import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { FormControl, FormGroup } from '@angular/forms';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings, IcepanelSettings, IcecontrolPermission } from '../../components/models/icesettings';
import { userTypes } from '../../login/login.config';

@Component({
  selector: 'icetextarea',
  templateUrl: './icetextarea.component.html',
  styleUrls: ['./icetextarea.component.scss']
})
export class IcetextareaComponent implements OnInit {
  // Input Members
  @Input() placeholder: string = "";
  @Input() id: string = "";
  @Input() properties: any = {};
  @Input() ctrl: IcecontrolSettings = null;
  @Output() textChanged: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  // Data Members
  iceFormControl: FormControl = null;
  permission: IcecontrolPermission = null;
  dataChanged: boolean = false;

  constructor() { }

  ngOnInit() {
    try {
      this.permission = this.ctrl.permissions ? this.ctrl.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);
      this.iceFormControl = this.ctrl.getFormControl();

      if (this.iceFormControl == null) {
        this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
      }
      if (this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly) {
        this.iceFormControl.disable();
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  onInputChange(event, index) {
    this.dataChanged = true;
  }

  onFocusOutChange(event, index) {
    if (this.dataChanged) {
      this.textChanged.emit(event);

      // emit to control observers
      if (this.ctrl.getChangeControlEvent() != null) {
        this.ctrl.getChangeControlEvent().emit(event);
      }
      this.dataChanged = false;
    }
  }

  getRows(): string {
    if (this.ctrl == null || this.ctrl.properties == null) return "";

    return this.ctrl.properties.rows == null ? "" : this.ctrl.properties.rows;
  }

  getCols(): string {
    if (this.ctrl == null || this.ctrl.properties == null) return "";

    return this.ctrl.properties.cols == null ? "" : this.ctrl.properties.cols;
  }

  getValue(): string | number {
    return this.iceFormControl.value;
  }
}
